/* Purpose: Styled buttons to be used throughout the app to create uniformity
 * Props: SubmitButton: text (str)
 *                      onClick (func)
 *                      width (str) --optional
 *                      extraClasses (str) --optional
 *        DownloadFileButton: text (str)
 *                            filePath (str)
 *                            onClick (func)
 *        UploadMoreButton: onClick (func)
 *        NavButton: text (str)
 *                   onClick (func)
 * Possible Exports: SubmitButton (default)
 *                   DownloadFileButton
 *                   UploadMoreButton
 *                   NavButton
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from 'react';
import { Button } from 'react-bootstrap';
import '../custom.scss'
import Spinner from 'react-bootstrap/Spinner';



const SubmitButton = (props) => {
    const text = props.text;
    const width = props.width?props.width:"25"
    const extraClasses = props.className || ""
    return(
            <Button variant = "secondary" className = {"m-3 w-"+width + " " + extraClasses} onClick = {props.onClick} width = {width}>
                {text.includes("...") && 
                    (<Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                    />)}      
                    {text}
            </Button>
    )
}

const DownloadFileButton = (props) => {
    const filePath = props.filePath;
    const brokenDownPath = filePath.split("/");
    const fileName = brokenDownPath[brokenDownPath.length - 1];
    const buttonText = props.text;


    return(
        <a target="_blank" rel="noopener noreferrer" href = {filePath} download = {fileName}>
            <Button variant = "light" size = "sm" onClick = {props.onClick} >{buttonText}</Button>
        </a>
    )
}

const UploadMoreButton = (props) => {
    return(
       <Button variant = "light"  onClick = {props.onClick}>Upload More</Button> 
    )
    
}

const NavButton = (props) => {
    return (
        <Button variant = "link" className = "m-2" onClick = {props.onClick} width = "20%">{props.text}</Button>
    )
}

export default SubmitButton;
export {
    DownloadFileButton,
    UploadMoreButton,
    NavButton
};